<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="身份证" prop="idCard">
                <a-input v-model="queryParam.idCard" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="推荐官专员姓名" prop="topUserNickname">
                <a-input v-model="queryParam.topUserNickname" placeholder="请输入" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">审核成功</a-select-option>
                  <a-select-option :value="2">审核失败</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="来源渠道" prop="sourceChannel">
                  <a-select placeholder="请选择" v-model="queryParam.sourceChannel" allow-clear>
                    <a-select-option
                      v-for="(sourceChannel,index) in sourceChannelList"
                      :key="index"
                      :value="sourceChannel.id">
                      {{ sourceChannel.content }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="来源类型" prop="sourceType">
                  <a-select v-model="queryParam.sourceType" placeholder="请选择" allow-clear>
                    <a-select-option value="1">平台分享</a-select-option>
                    <a-select-option value="2">招聘专员分享</a-select-option>
                    <a-select-option value="3">推荐官分享</a-select-option>
                    <a-select-option value="4">推荐官专员分享</a-select-option>
                    <a-select-option value="5">驻场客服分享</a-select-option>
                    <a-select-option value="6">其他</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最近访问地" prop="recentlyVisitedPlace">
                  <a-input v-model="queryParam.recentlyVisitedPlace" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="邀请所属" prop="inviteUserNickname">
                  <a-input v-model="queryParam.inviteUserNickname" placeholder="请输入" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="注册时间" prop="createTime">
                  <a-range-picker
                    style="width: 100%"
                    v-model="createTime"
                    valueFormat="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:referrals:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <set-top-form
        ref="setTopForm"
      />
      <user-form
        ref="userForm"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2400}"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="fileUrl" slot-scope="text, record">
          <a v-if="record.fileUrl" @click="copyToClipboard(record.fileUrl)">点击复制</a>
        </span>
        <span slot="status" slot-scope="text, record">
          <div>
            <a-tag v-if="record.status == 0">待审核</a-tag>
            <a-tag v-if="record.status == 1">审核成功</a-tag>
            <a-tag v-if="record.status == 2">审核失败</a-tag>
          </div>
        </span>
        <span slot="bankStatus" slot-scope="text, record">
          <div>
            <a-tag v-if="record.bankStatus == 0">未提交</a-tag>
            <a-tag v-if="record.bankStatus == 1">待审核</a-tag>
            <a-tag v-if="record.bankStatus == 2">审核成功</a-tag>
            <a-tag v-if="record.bankStatus == 3">审核失败</a-tag>
            <a-tag v-if="record.bankStatus == 4">解绑待审核</a-tag>
            <a-tag v-if="record.bankStatus == 5">解绑审核成功</a-tag>
          </div>
        </span>
        <span slot="userStatus" slot-scope="text, record">
          <div>
            <a-switch 
              :checked="record.userStatus === 1"
              @change="(checked) => handleStatusChange(checked, record)"
            >
            </a-switch>
          </div>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:referrals:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:referrals:edit']">
            <a-icon type="edit" />查看/编辑
          </a>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <a-icon type="double-right"/>
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['user:referrals:edit']">
               <a v-if="record.status == 0" @click="checkStatus(record.id)" v-hasPermi="['user:referrals:edit']">
                 <a-icon type="check" />审核
               </a>
                <a v-if="record.status != 0" disabled>
                  <a-icon type="check" />已审核
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['user:referrals:edit']">
               <a v-if="record.bankStatus == 0" disabled>
                <a-icon type="check" />银行卡待绑定
              </a>
              <a v-else-if="record.bankStatus == 1 || record.bankStatus == 4" @click="checkBankStatus(record)" v-hasPermi="['user:referrals:edit']">
                <a-icon type="check" />银行卡审核
              </a>
               <a v-else disabled>
                  <a-icon type="check" />银行卡已审核
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['user:referrals:edit']">
              <a @click="$refs.setTopForm.handleAdd(record.id)" v-hasPermi="['user:referrals:edit']">
                <a-icon/>绑定推荐官专员
              </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['user:referrals:edit']">
                <a @click="$refs.userForm.show(record)" v-hasPermi="['user:referrals:edit']">
                  <a-icon/>会员信息
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['user:referrals:remove']">
                <a @click="handleDelete(record)" v-hasPermi="['user:referrals:remove']">
                  <a-icon type="delete" />删除
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <a-modal
        :title="operateTitle"
        :width="500"
        :visible="operateOpen"
        @cancel="operateClose"
        @ok="operateOk"
      >
        <a-form-model v-if="operateType == 2 || operateType == 3">
          <a-form-model-item label="卡号">
            {{ thisData.bankNo }}
          </a-form-model-item>
          <a-form-model-item label="银行卡名称">
            {{ thisData.bankName }}
          </a-form-model-item>
          <a-form-model-item label="开户行">
            {{ thisData.bankSubName }}
          </a-form-model-item>
          <a-form-model-item label="开户地">
            {{ thisData.bankAddress }}
          </a-form-model-item>
          <a-form-model-item label="真实姓名">
            {{ thisData.bankRealName }}
          </a-form-model-item>
          <a-form-model-item label="手机号">
            {{ thisData.bankMobile }}
          </a-form-model-item>
          <a-form-model-item label="提交时间">
            {{ parseTime(thisData.bankCreateTime) }}
          </a-form-model-item>
        </a-form-model>
        <a-radio-group v-model="status">
          <a-radio v-if="operateType == 1" :value="1">审核成功</a-radio>
          <a-radio v-if="operateType == 1" :value="2">审核失败</a-radio>
          <a-radio v-if="operateType == 2" :value="2">审核成功</a-radio>
          <a-radio v-if="operateType == 2" :value="3">审核失败</a-radio>
          <a-radio v-if="operateType == 3" :value="5">审核成功</a-radio>
          <a-radio v-if="operateType == 3" :value="2">审核失败</a-radio>
        </a-radio-group>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageReferrals, updateUserStatus, delReferrals, updateReferrals, updateBank } from '@/api/user/referrals'
import CreateForm from './modules/CreateForm'
import SetTopForm from './modules/SetTopForm'
import { tableMixin } from '@/store/table-mixin'
import UserForm from './modules/UserForm'
import { querySourceChannelList } from '@/api/biz/user'

export default {
  name: 'Referrals',
  components: {
    UserForm,
    CreateForm,
    SetTopForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      operateTitle: null,
      operateOpen: null,
      operateType: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      id: null,
      thisData: {},
      status: 1,
      total: 0,
      sourceChannelList: [],
      // 查询参数
      queryParam: {
        nickname: null,
        mobile: null,
        idCard: null,
        topUserNickname: null,
        userId: null,
        idCardFront: null,
        idCardReverse: null,
        fileUrl: null,
        status: null,
        cateName: null,
        sourceChannel: null,
        sourceType: null,
        recentlyVisitedPlace: null,
        inviteUserNickname: null,
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'realName',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          fixed: 'left',
          width: 120,
          align: 'center'
        },
        {
          title: '编号',
          dataIndex: 'id',
          width: 180,
          align: 'center'
        },
        {
          title: '微信',
          dataIndex: 'wxCode',
          width: 120,
          align: 'center'
        },
        {
          title: '身份证',
          dataIndex: 'idCard',
          width: 120,
          align: 'center'
        },
        {
          title: '来源渠道',
          dataIndex: 'sourceChannelName',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '来源类型',
          dataIndex: 'sourceType',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: function (sourceType) {
            if (sourceType == 1) {
              return '平台分享'
            } else if (sourceType == 2) {
              return '招聘专员分享'
            } else if (sourceType == 3) {
              return '推荐官分享'
            } else if (sourceType == 4) {
              return '推荐官专员分享'
            } else if (sourceType == 5) {
              return '驻场客服分享'
            } else if (sourceType == 6) {
              return '其他'
            }
          }
        },
        {
          title: '邀请所属',
          dataIndex: 'inviteUserNickname',
          width: 120,
          align: 'center'
        },
        {
          title: '推荐官专员姓名',
          dataIndex: 'topUserNickname',
          width: 120,
          align: 'center'
        },
        {
          title: '最近访问地',
          dataIndex: 'recentlyVisitedPlace',
          width: 120,
          align: 'center'
        },
        {
          title: '推荐员工数量',
          dataIndex: 'recommendUserCount',
          width: 120,
          align: 'center'
        },
        {
          title: '报备面试数量',
          dataIndex: 'reportCount',
          width: 120,
          align: 'center'
        },
        {
          title: '佣金合计',
          dataIndex: 'moneyCount',
          width: 120,
          align: 'center'
        },
        {
          title: '合同',
          dataIndex: 'fileUrl',
          width: 120,
          scopedSlots: { customRender: 'fileUrl' },
          align: 'center'
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 120,
          align: 'center'
        },
        {
          title: '操作状态',
          dataIndex: 'userStatus',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'userStatus' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '银行卡状态',
          dataIndex: 'bankStatus',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'bankStatus' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 240,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      createTime: null
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.querySourceChannel()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    querySourceChannel() {
      querySourceChannelList().then(response => {
        this.sourceChannelList = response.data
      })
    },
    checkBankStatus(record) {
      debugger
      this.thisData = record
      this.id = record.bankId
      const status = record.bankStatus
      if (status == 1) {
        this.operateTitle = '审核推荐官银行卡绑定'
        this.operateType = 2
        this.status = 2
      }
      if (status == 4) {
        this.operateTitle = '审核推荐官银行卡解绑'
        this.operateType = 3
        this.status = 5
      }
      this.operateOpen = true
    },
    operateOk() {
      const that = this
      const param = {
        id: that.id,
        status: that.status
      }
      if (that.operateType == 1) {
        updateReferrals(param).then(() => {
          that.getList()
          that.$message.success(
            '操作成功',
            3
          )
          this.operateClose()
        })
      }
      if (that.operateType == 2 || that.operateType == 3) {
        updateBank(param).then(() => {
          that.getList()
          that.$message.success(
            '操作成功',
            3
          )
          this.operateClose()
        })
      }
    },
    operateClose() {
      this.operateOpen = false
      this.operateTitle = null
      this.operateType = null
      this.id = null
      this.status = 1
    },
    checkStatus(id) {
      this.id = id
      this.operateTitle = '审核推荐官信息'
      this.operateOpen = true
      this.operateType = 1
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('内容已复制到剪贴板')
      } catch (err) {
        this.$message.success('复制到剪贴板失败')
      }
    },
    handleStatusChange(checked, record) {
      record.userStatus = checked ? 1 : 0
      this.updateUserStatus(record)
    },
    updateUserStatus(record) {
      // 更改状态
      let param = {
        ids: [record.userId],
        status: record.userStatus ? 1 : 0
      }
      updateUserStatus(param).then(response => {
        this.$message.success(
          '修改成功',
          3
        )
        this.$emit('ok')
      }).finally(() => {
        this.getList()
      })
    },
    /** 查询推荐官申请列表 */
    getList () {
      this.loading = true
     pageReferrals(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      if (this.createTime) {
        this.queryParam.startTime = this.createTime[0]
        this.queryParam.endTime = this.createTime[1]
      }
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.createTime = null
      this.queryParam = {
        userId: undefined,
        idCardFront: undefined,
        idCardReverse: undefined,
        fileUrl: undefined,
        status: undefined,
        cateName: undefined,
        sourceChannel: undefined,
        sourceType: undefined,
        recentlyVisitedPlace: undefined,
        inviteUserNickname: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delReferrals(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/user-referrals/export', {
            ...that.queryParam
          }, `推荐官申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
